import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, withRouter } from 'react-router-dom';
import { setupNavigation } from "../../redux/actions/navItemsActions";
import { loadGroup, loadGroupByFriendlyUrl, editGroup, uploadAvatar, uploadBanner, addUserToGroup, requestGroupMembership, removeUserFromGroup, archiveGroup, reactivateGroup, getRecentGroups } from "../../redux/actions/groupActions";
import Spinner from "../common/Spinner";
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../api/config";
import { isGroupNameUnique } from "../../api/groupsApi";
import { toast } from "react-toastify";
import GroupForm from "./GroupForm";
import SettingsAvatarForm from "../user/SettingsAvatarForm";
import RouteSearch from "../routes/RouteSearch";
import PostFeedControl from "../postComments/PostFeedControl";
import EventSearch from "../events/EventSearch";
import GroupMemberOptionControl from "./GroupMemberOptionControl";
import GroupAdminOptionControl from "./GroupAdminOptionControl";
import GroupMemberRequestControl from "./GroupMemberRequestControl";
import GroupMemberRejectionControl from "./GroupMemberRejectionControl";
import SelectGroupMembersControl from "./SelectGroupMembersControl";
import $ from 'jquery';
import "./Group.css";


function GroupPage({
    setupNavigation,
    routes,
    groupId,
    groupFriendlyUrl,
    loadGroup,
    loadGroupByFriendlyUrl,
    requestGroupMembership,
    removeUserFromGroup,
    archiveGroup,
    reactivateGroup,
    getRecentGroups,
    groups,
    editGroup,
    uploadAvatar,
    uploadBanner,
    user,
    history,
    ...props
}) {

    const [processing, setProcessing] = useState(true);
    const [errors, setErrors] = useState({});
    const [activeForm, setActiveForm] = useState({ form: "timeline" });

    const [group, setGroup] = useState(null);
    const [groupDetails, setGroupDetails] = useState({ name: "", description: "", friendlyUrl: "", joiningInfo: "", access: "", private: false });
    const [avatarDetails, setAvatarDetails] = useState({ src: "", preview: "" });
    const [userIsAdmin, setUserIsAdmin] = useState(false);
    const [userIsMember, setUserIsMember] = useState(false);
    const [userIsPending, setUserIsPending] = useState(false);
    const [userIsRejected, setUserIsRejected] = useState(false);
    const [rejectionReason, setRejectionReason] = useState("");
    const [interestingGroups, setInterestingGroups] = useState({});

    useEffect(() => {
        document.title = "Group | JustGoRide";
        setProcessing(true);
        var groupLoaded = false; 
        if (group == null || (group.id !== groupId && group.friendlyUrl.toLowerCase() !== groupFriendlyUrl.toLowerCase())) {
            reloadGroup();
        }
        else {
            setProcessing(false);
        }
    }, [groupId]);


    useEffect(() => {
        if (props.location.state && props.location.state.source == "notifications") {
            setProcessing(true);
            reloadGroup();
        }
    }, [props.location])

    useEffect(() => {
        if (groups.userGroups.length > 0) {
            groups.userGroups.map(g => {
                if ((g.id === groupId || g.friendlyUrl.toLowerCase() === groupFriendlyUrl.toLowerCase()) && g.administrators.length > 0) {
                    setGroupDetails(g);
                    setGroup(g);
                    setAccess(g);
                    if (Number.isNaN(groupId)) {
                        groupId = g.id;
                    }
                    if (g.avatarAvailable) {
                        var avatar = { src: "", preview: `${apiConfig.API_URL}groups/avatar/${g.id}.png` }
                        setAvatarDetails(avatar)
                    }
                    setProcessing(false);
                    return;
                }
            })
        }
    }, [groups])

    useEffect(() => {
        if (group) {
            setupNavigation(userIsAdmin ? getNavigationItems(group) : { sections: [interestingGroups] });
        }
    }, [userIsAdmin])

    useEffect(() => {
        if (group) {
            setupNavigation(userIsAdmin ? getNavigationItems(group) : { sections: [interestingGroups] });
        }
    }, [interestingGroups])

    function reloadGroup() {
        if (Number.isNaN(groupId)) {
            loadGroupByFriendlyUrl(groupFriendlyUrl)
                .then((g) => {
                    setGroupDetails(g);
                    setGroup(g);
                    if (g.avatarAvailable) {
                        var avatar = { src: "", preview: `${apiConfig.API_URL}groups/avatar/${g.id}.png` }
                        setAvatarDetails(avatar)
                    }
                    setAccess(g)
                    groupId = g.id;
                    getPopularGroups(); 
                    setProcessing(false);
                })
                .catch(error => {
                    if (error.message === "401" || error.message === "404") {
                        history.push("/resourceunavailable");
                        return;
                    }
                    console.error("Loading group failed: " + error);
                    history.push("/oops");
                });
        }
        else {
            loadGroup(groupId)
                .then((g) => {
                    setGroupDetails(g);
                    setGroup(g);
                    if (g.avatarAvailable) {
                        var avatar = { src: "", preview: `${apiConfig.API_URL}groups/avatar/${g.id}.png` }
                        setAvatarDetails(avatar)
                    }
                    setAccess(g)
                    getPopularGroups(); 
                    setProcessing(false);
                })
                .catch(error => {
                    if (error.message === "401" || error.message === "404") {
                        history.push("/resourceunavailable");
                        return;
                    }
                    console.error("Loading group failed: " + error);
                    history.push("/oops");
                });
        }
    } 

    function getNavigationItems(groupData) {

        var navItems = {
            sections: [
                {
                    name: 'Members',
                    items: [
                        {
                            func: onAddMember,
                            text: 'Add Members',
                            icon: 'fas fa-user-plus'
                        },
                        {
                            func: onManageRejections,
                            text: 'Rejected Members',
                            icon: 'fas fa-user-minus'
                        }
                    ]
                },
                {
                    name: 'Administration',
                    items: [
                        {
                            func: onEditGroup,
                            text: 'Edit Group',
                            icon: 'fas fa-users-cog'
                        },
                        {
                            func: onUploadAvatar,
                            text: 'Change Avatar',
                            icon: 'fas fa-user'
                        },
                        {
                            func: onUploadBanner,
                            text: 'Change Banner',
                            icon: 'fas fa-image'
                        },
                        {
                            func: groupData.archived ? onReactivateGroup : onArchiveGroup,
                            text: groupData.archived ? 'Reactivate Group' : 'Archive Group',
                            icon: groupData.archived ? 'fas fa-box-open' : 'fas fa-archive'
                        }
                    ]
                },
                interestingGroups
            ]
        };
        return navItems;
    }


    function setAccess(group) {

        if (group.private) {
            var hasAccess = false; 
            group.members.map(member => {
                if (member.userId.toUpperCase() == user.id.toUpperCase()) {
                    hasAccess = true; 
                }
                
            });
            if (!hasAccess) {
                group.administrators.map(admin => {
                    if (admin.userId.toUpperCase() == user.id.toUpperCase()) {
                        hasAccess = true;
                    }
                });
            }
            if (!hasAccess) {
                history.push("/resourceunavailable");
                return;
            }
        }

        group.administrators.map(admin => {
            if (admin.userId.toUpperCase() == user.id.toUpperCase()) {
                setUserIsAdmin(true);
                setUserIsMember(true);
                return; 
            }
        });

        group.memberRequests.map(request => {
            if (request.userId.toUpperCase() == user.id.toUpperCase())
            {
                setUserIsPending(true);
            }
            
        });

        group.members.map(member => {
            if (member.userId.toUpperCase() == user.id.toUpperCase()) {
                setUserIsMember(true);
            }
            
        });

        group.rejectedMemberRequests.map(rejected => {
            if (rejected.userId.toUpperCase() == user.id.toUpperCase()) {
                setUserIsRejected(true);
                setRejectionReason(rejected.rejectionReason)
            }
        });
    }

    function getPopularGroups() {
        getRecentGroups().then((groups) => {
            var items = [];
            groups.map(g => {
                items.push({
                    path: `/groups/${g.id}`,
                    text: g.name,
                    avatar: { type: 'groups', available: g.avatarAvailable, id: g.id }
                })
            })
            items.push({
                path: '/groups',
                text: 'See all Groups',
                icon: 'fas fa-users'
            })
            var navSection = {
                name: 'Groups',
                showTitle: true,
                items: items
            };
            setInterestingGroups(navSection);
        })
    }

    function setForm(e) {
        e.preventDefault();
        var form = e.target.title;
        setActiveForm(setActiveForm => ({
            ...setActiveForm,
            form: form
        }));
    }

    function handleChange(e) {
        var { name, value } = e.target;
        if (name === "private") {
            value = e.target.checked;
        }
        setGroupDetails(prevGroupDetails => ({
            ...prevGroupDetails,
            [name]: value
        }));
    }

    function onSave(e) {
        e.preventDefault();

        const errors = {};

        if (!groupDetails.name) {
            errors.name = "A group name is required.";
            setErrors(errors);
            return;
        }

        if (!groupDetails.access || groupDetails.access === "") {
            errors.access = "Please set the group access level.";
            setErrors(errors);
            return;
        }

        //Do a quick call to ensure group name and URL is unique here!

        isGroupNameUnique(groupDetails.id, groupDetails.name, groupDetails.friendlyUrl)
            .then(results => {
                if (!results.nameUnique) {
                    errors.name = "This group name already exists";
                }

                if (!results.friendlyUrlUnique) {
                    errors.friendlyUrl = "URL already in use";
                }

                if (!results.friendlyUrlUnique || !results.nameUnique) {
                    setErrors(errors);
                    return;
                }

                $('#editGroup').modal('hide')
                setProcessing(true);

                sumbitSave(groupDetails);
            })
    }

    function sumbitSave(groupDetails) {
        editGroup(groupDetails)
            .then((group) => {
                setProcessing(false);
                setErrors({})
                toast.success(`Group Edited`);
            })
            .catch(error => {
                setProcessing(false);
                setErrors({ onSave: error.message });
            });
    }

    function onEditGroup(e) {
        e.preventDefault();
        $('#editGroup').modal('show')
    }

    function onCancelSave(e) {
        e.preventDefault();
        $('#editGroup').modal('hide')
    }

    function onArchiveGroup(e) {
        e.preventDefault();
        $('#archiveGroup').modal('show')
    }

    function onConfirmArchiveGroup(e) {
        e.preventDefault();
        $('#archiveGroup').modal('hide')

        archiveGroup(group.id)
            .then(() => {
                toast.success(`${group.name} Archived`);
            });
    }

    function onReactivateGroup(e) {
        e.preventDefault();
        $('#reactiveGroup').modal('show')
    }

    function onConfirmReactivateGroup(e) {
        e.preventDefault();
        $('#reactiveGroup').modal('hide')

        reactivateGroup(group.id)
            .then(() => {
                toast.success(`${group.name} Reactivated!`);
            });
    }

    
    //ADD MEMBERS

    function onAddMember(e) {
        e.preventDefault();
        $('#addMember').modal('show')
    }

    function onCancelAdd(e) {
        if (e) {
            e.preventDefault();
        }
        $('#addMember').modal('hide')
    }

    function requestMembership(e) {
        e.preventDefault();
        requestGroupMembership(user, group.id)
            .then(() => {
                toast.success(`Request to Join ${group.name} Submitted`);
            });
    }

    //REJECTED REQUESTS

    function onClearAllRejections(e) {
        e.preventDefault();
        alert('Clear everything');
    }

    function onCancelRejectionModal(e) {
        e.preventDefault();
        $('#rejectedMembers').modal('hide');
    }
    
    function onManageRejections(e) {
        e.preventDefault();
        $('#rejectedMembers').modal('show')
    }

    //AVATAR

    function onUploadAvatar(e) {
        e.preventDefault();
        $('#uploadAvatar').modal('show')
    }

    function onAvatarClose() {
    }


    function onAvatarCrop(avatarPreview) {
        setAvatarDetails(prevAvatarDetails => ({
            ...prevAvatarDetails,
            preview: avatarPreview
        }));
    }


    function onAvatarBeforeFileLoad(elem) {
    }

    function onAvatarSave(event) {
        event.preventDefault();

        $('#uploadAvatar').modal('hide')
        setProcessing(true);

        var avatar = avatarDetails;
        avatar.version = ++group.avatarVersion;
        avatar.groupId = group.id;
        uploadAvatar(avatar, groupDetails).then(() => {
                toast.success("Avatar Saved");
                setErrors({});
                setProcessing(false);
            })
            .catch(error => {
                setProcessing(false);
                setErrors({ onAvatarSave: error.message });
            });
    }

    //BANNER

    function onUploadBanner(e) {
        e.preventDefault(); 
        $("#profile-banner-control").click();
    }

    async function uploadProfileBanner(e) {
        if (e.target.files.length > 0) {
            setProcessing(true);
            const config = {
                file: e.target.files[0],
                maxSize: 1280
            };
            const resizedImage = await resizeImage(config)
            var banner = { fileName: resizedImage.data, version: ++group.bannerVersion, groupId: group.id };

            uploadBanner(banner)
                .then(() => {
                    toast.success("Banner Saved");
                    setErrors({});
                    setProcessing(false)
                })
        }
    }

    //EVENTS

    function getRoutes(){

        var routeChoice = [];

        if (group.sharedRoutes) {
            group.sharedRoutes.map(route => {
                routeChoice.push({ value: route.routeId, text: route.routeName })
            })
        }

        return routeChoice; 
    }


    function onLeaveGroup(e) {
        e.preventDefault();
        $("#confirmLeaving").modal("hide");
        removeUserFromGroup(user.id, group.id)
            .then(() => {
                history.push("/user/profile");
                toast.success(`You have left ${group.name}.`);
            });
    }

    return (
            processing ?
                <Spinner /> :
                (
                (group && !(group.private && !userIsMember)) && 
                <div>
                    <div className="profile-banner">
                        <div className="profile-banner-info">
                            <h2 className="profile-banner-title">{group.name}</h2>
                            <p className="profile-banner-description d-none d-sm-block">{group.description}</p>
                        </div>
                        {group.bannerAvailable &&
                            <React.Fragment>
                                <div className="profile-banner-bg-img-gradient"></div>
                                <img className="profile-banner-bg-img" src={`${apiConfig.API_URL}groups/banner/${group.id}.png?v=${group.bannerVersion}`} />
                            </React.Fragment>
                        }
                        <div className="profile-avatar-container">
                            {group.avatarAvailable ?
                                
                                <React.Fragment>
                                    <UserAvatar className="default-avatar d-sm-none" size="100" name={`${group.name}`} src={`${apiConfig.API_URL}groups/avatar/${group.id}.png?v=${group.avatarVersion}`} />
                                    <UserAvatar className="default-avatar d-none d-sm-block" size="150" name={`${group.name}`} src={`${apiConfig.API_URL}groups/avatar/${group.id}.png?v=${group.avatarVersion}`} />
                                </React.Fragment>
                                :
                                <div className="profile-banner-avatar"><span className="fas fa-users"></span></div>
                            }
                        </div>
                    </div>
                    {(group.closed && !userIsMember) ?
                        <div className="row justify-content-md-center">
                            <div className="col-6 mt-5 text-center">
                                <h5>{`${group.name} is a Closed Group`}</h5>
                                {userIsRejected ?
                                    <React.Fragment>
                                        <p>You have been declined access to this group for the following reason:</p>
                                        <p>{rejectionReason}</p>
                                    </React.Fragment>
                                    : ""}
                                {userIsPending ? <p>Your request to join this group is pending.</p> : ""}
                                {!userIsPending && !userIsRejected ?
                                    <React.Fragment>
                                        <p>{group.joiningInfo}</p>
                                        <button className="btn btn-primary" onClick={requestMembership} >Request to Join</button>
                                    </React.Fragment>
                                    : ""
                                }
                            </div>
                        </div>
                        :
                        (<div className="group-body">
                            {group.archived &&
                                <div className="group-banner-notice alert alert-warning mb-0" role="alert">
                                    This Group has been archived and is no longer active.
                                </div>
                            }
                            <div className="profile-tab">
                                <ul className="nav nav-tabs">
                                    <li className="nav-item">
                                        <a title="timeline" className={activeForm.form == "timeline" ? "nav-link d-sm-none active" : "nav-link d-sm-none"} href="#" onClick={setForm}><span title="timeline" className="fas fa-clock"></span></a>
                                        <a title="timeline" className={activeForm.form == "timeline" ? "nav-link d-none d-sm-inline active" : "nav-link d-none d-sm-inline"} href="#" onClick={setForm}><span title="timeline" className="fas fa-clock mr-1"></span>Timeline</a>
                                    </li>
                                    <li className="nav-item">
                                        <a title="routes" className={activeForm.form == "routes" ? "nav-link d-sm-none active" : "nav-link d-sm-none"} href="#" onClick={setForm}><span title="routes" className="fas fa-route"></span></a>
                                        <a title="routes" className={activeForm.form == "routes" ? "nav-link d-none d-sm-inline active" : "nav-link d-none d-sm-inline"} href="#" onClick={setForm}><span title="routes" className="fas fa-route mr-1"></span>Routes</a>
                                    </li>
                                    <li className="nav-item">
                                        <a title="members" className={activeForm.form == "members" ? "nav-link d-sm-none active" : "nav-link d-sm-none"} href="#" onClick={setForm}><span title="members" className="fas fa-users"></span></a>
                                        <a title="members" className={activeForm.form == "members" ? "nav-link d-none d-sm-inline active" : "nav-link d-none d-sm-inline"} href="#" onClick={setForm}><span title="members" className="fas fa-users mr-1"></span>Members({group.administrators.length + group.members.length})</a>
                                    </li>
                                    <li className="nav-item">
                                        <a title="events" className={activeForm.form == "events" ? "nav-link d-sm-none active" : "nav-link d-sm-none"} href="#" onClick={setForm}><span title="events" className="far fa-calendar-alt"></span></a>
                                        <a title="events" className={activeForm.form == "events" ? "nav-link d-none d-sm-inline active" : "nav-link d-none d-sm-inline"} href="#" onClick={setForm}><span title="events" className="far fa-calendar-alt mr-1"></span>Events</a>
                                    </li>
                                </ul>
                            </div>
                            <div>
                                {
                                    (() => {
                                        switch (activeForm.form) {
                                            case "timeline":
                                                return (
                                                    <PostFeedControl mode={"Group"} refId={group.id} active={!group.archived}/>
                                                )
                                            case 'routes':
                                                return (
                                                    <RouteSearch mode={"grouproutes"} groupId={group.id} />
                                                )
                                            case 'members':
                                                return (
                                                    <div className="group-members">
                                                        <div className="group-toolbar top-form">
                                                            {group.ownerId.toUpperCase() != user.id.toUpperCase() &&
                                                                <button className="btn btn-sm btn-info" data-toggle="modal" data-target="#confirmLeaving">Leave Group</button>
                                                            }
                                                        </div>
                                                        {userIsAdmin && group.memberRequests.length > 0 &&
                                                        <React.Fragment>
                                                            <h5 className="ml-3">Membership Request</h5>
                                                            <table className="table col-11 mt-3 ml-auto mr-auto">
                                                                <tbody>
                                                                    {
                                                                        group.memberRequests.map((resultingUser, index) => {
                                                                            return (
                                                                                <tr key={resultingUser.userId}>
                                                                                    <td width="35px" scope="row">
                                                                                        {(user.id && user.id.toUpperCase() == resultingUser.userId.toUpperCase()) ?
                                                                                            <UserAvatar size="35" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                                                                            :
                                                                                            <UserAvatar size="35" name={`${resultingUser.firstName} ${resultingUser.surname}`} src={resultingUser.hasAvatar ? `${apiConfig.API_URL}user/avatar/${resultingUser.userId}.png` : ""} />
                                                                                        }
                                                                                    </td>
                                                                                    <td><Link to={"/user/profile/" + resultingUser.userId}>{`${resultingUser.firstName} ${resultingUser.surname}`}</Link></td>
                                                                                    
                                                                                    <td width="20px" >
                                                                                        <GroupMemberRequestControl group={group} subjectUser={resultingUser} />
                                                                                        </td>
                                                                                        
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                </tbody>
                                                            </table>
                                                        </React.Fragment>
                                                        }
                                                        <h5 className="ml-3">Group Admins</h5>
                                                        <table className="table col-11 mt-3 ml-auto mr-auto">
                                                            <tbody>
                                                                {
                                                                    group.administrators.map((resultingUser, index) => {
                                                                        return (
                                                                            <tr key={resultingUser.userId}>
                                                                                <td width="35px" scope="row">
                                                                                    {(user.id && user.id.toUpperCase() == resultingUser.userId.toUpperCase()) ?
                                                                                        <UserAvatar size="35" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                                                                        :
                                                                                        <UserAvatar size="35" name={`${resultingUser.firstName} ${resultingUser.surname}`} src={resultingUser.hasAvatar ? `${apiConfig.API_URL}user/avatar/${resultingUser.userId}.png` : ""} />
                                                                                    }
                                                                                </td>
                                                                                <td><Link to={"/user/profile/" + resultingUser.userId}>{`${resultingUser.firstName} ${resultingUser.surname}`}</Link></td>
                                                                                {userIsAdmin &&
                                                                                    <td width="20px" >
                                                                                        <GroupAdminOptionControl group={group} subjectUser={resultingUser} />
                                                                                    </td>
                                                                                 }
                                                                            </tr>
                                                                        );
                                                                    })}
                                                            </tbody>
                                                        </table>
                                                        <h5 className="ml-3">Members</h5>
                                                        <table className="table col-11 mt-3 ml-auto mr-auto">
                                                            <tbody>
                                                                {
                                                                    group.members.map((resultingUser, index) => {
                                                                        return (
                                                                            <tr key={resultingUser.userId}>
                                                                                <td width="35px" scope="row">
                                                                                    {(user.id && user.id.toUpperCase() == resultingUser.userId.toUpperCase()) ?
                                                                                        <UserAvatar size="35" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                                                                        :
                                                                                        <UserAvatar size="35" name={`${resultingUser.firstName} ${resultingUser.surname}`} src={resultingUser.hasAvatar ? `${apiConfig.API_URL}user/avatar/${resultingUser.userId}.png` : ""} />
                                                                                    }
                                                                                </td>
                                                                                <td><Link to={"/user/profile/" + resultingUser.userId}>{`${resultingUser.firstName} ${resultingUser.surname}`}</Link></td>
                                                                                {userIsAdmin &&
                                                                                    <td width="20px" >
                                                                                        <GroupMemberOptionControl group={group} subjectUser={resultingUser} />
                                                                                    </td>
                                                                                 }
                                                                            </tr>
                                                                        );
                                                                    })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )
                                            case 'events':
                                                return (
                                                    <EventSearch group={group} routes={getRoutes()} allowEventCreation={true}/>
                                                )
                                            default:
                                                return null;
                                        }
                                    })()
                                }
                            </div>
                        </div>
                        )}

                        <input type="file" accept="image/*" style={{ display: "none" }} id="profile-banner-control" className="form-control" onChange={uploadProfileBanner} />
                       
                        <div className="modal fade" id="editGroup" tabIndex="-1" role="dialog" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                    <h5 className="modal-title">Edit Group Details</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <GroupForm
                                            group={groupDetails}
                                            errors={errors}
                                            onChange={handleChange}
                                            onSave={onSave}
                                            onCancel={onCancelSave}
                                            processing={processing}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="archiveGroup" tabIndex="-1" role="dialog" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                        <h5 className="modal-title">Archive Group?</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <p>Are you sure that you want to archive this group?</p>
                                        <p>This will result in the members of the group no longer having access.</p>
                                        <p>You can reactivate the group at a later date if you wish.</p> 
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-link" data-dismiss="modal">No</button>
                                        <button type="button" className="btn btn-info" onClick={onConfirmArchiveGroup}>Yes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                        <div className="modal fade" id="reactiveGroup" tabIndex="-1" role="dialog" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                        <h5 className="modal-title">Archive Group?</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <p>Are you sure that you want to reactivate this group?</p>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-link" data-dismiss="modal">No</button>
                                        <button type="button" className="btn btn-info" onClick={onConfirmReactivateGroup}>Yes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="uploadAvatar" tabIndex="-1" role="dialog" aria-hidden="true">
                            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                        <h5 className="modal-title">Upload Group Avatar</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <SettingsAvatarForm
                                            avatar={avatarDetails}
                                            errors={errors}
                                            onCrop={onAvatarCrop}
                                            onClose={onAvatarClose}
                                            onBeforeFileLoad={onAvatarBeforeFileLoad}
                                            onSave={onAvatarSave}
                                            processing={processing}
                                        />
                                    </div>
                                </div>
                            </div>
                    </div>

                    <div className="modal fade" id="addMember" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                    <h5 className="modal-title">Invite New Members</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <SelectGroupMembersControl group={group} onCompletedSelection={onCancelAdd} />
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-link float-right" onClick={onCancelAdd}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal fade" id="confirmLeaving" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                    <h5 className="modal-title" >Leave Group?</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    Are you sure that you want to leave this group?
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-link" data-dismiss="modal">No</button>
                                    <button type="button" className="btn btn-info" onClick={onLeaveGroup}>Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal fade" id="rejectedMembers" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                    <h5 className="modal-title">Rejected Member Requests</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row justify-content-md-center mt-3">
                                        {group.rejectedMemberRequests.length > 0 ?
                                            <React.Fragment>
                                                <table className="table col-11">
                                                    <thead className="thead-light">
                                                        <tr>
                                                            <th scope="col"></th>
                                                            <th scope="col">Name</th>
                                                            <th scope="col">Reason</th>
                                                            <th scope="col">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            group.rejectedMemberRequests.map((resultingUser, index) => {
                                                                return (
                                                                    <tr key={resultingUser.userId}>
                                                                        <td width="35px" scope="row"><UserAvatar size="35" name={`${resultingUser.firstName} ${resultingUser.surname}`} src={resultingUser.hasAvatar ? `${apiConfig.API_URL}user/avatar/${resultingUser.userId}.png` : ""} /></td>
                                                                        <td><Link to={"/user/profile/" + resultingUser.userId}>{`${resultingUser.firstName} ${resultingUser.surname}`}</Link></td>
                                                                        <td>{resultingUser.rejectionReason}</td>
                                                                        <td width="20px" >
                                                                            <GroupMemberRejectionControl group={group} subjectUser={resultingUser} />
                                                                        </td>

                                                                    </tr>
                                                                );
                                                            })}
                                                    </tbody>
                                                </table>
                                                <div className="col-11">
                                                    {/* 
                                                    <button className="btn btn-primary float-right" onClick={onClearAllRejections}>
                                                        Clear All
                                                    </button>
                                                    */} 
                                                    <button className="btn btn-secondary float-right mr-1" onClick={onCancelRejectionModal}>
                                                        Cancel
                                                    </button>
                                                </div>
                                            </React.Fragment>
                                            :
                                            <React.Fragment>
                                                <p>There are currently no rejected member requests for this group.</p>
                                                <div className="col-11">
                                                    <button className="btn btn-link float-right mr-1" onClick={onCancelRejectionModal}>
                                                        Cancel
                                                </button>
                                                </div>
                                            </React.Fragment>
                                        }
                                    </div>    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                )
            
    );

}

GroupPage.propTypes = {
    setupNavigation: PropTypes.func.isRequired,
    groupId: PropTypes.number,
    groupFriendlyUrl: PropTypes.string,
    routes: PropTypes.object, 
    loadGroup: PropTypes.func.isRequired,
    loadGroupByFriendlyUrl: PropTypes.func.isRequired,
    editGroup: PropTypes.func.isRequired,
    uploadAvatar: PropTypes.func.isRequired,
    uploadBanner: PropTypes.func.isRequired,
    addUserToGroup: PropTypes.func.isRequired,
    requestGroupMembership: PropTypes.func.isRequired,
    removeUserFromGroup: PropTypes.func.isRequired,
    archiveGroup: PropTypes.func.isRequired,
    reactivateGroup: PropTypes.func.isRequired,
    getRecentGroups: PropTypes.func.isRequired,
    groups: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
}


function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id; 
    return {
        groupId: parseInt(id),
        groupFriendlyUrl: id,
        groups: state.groups,
        routes: state.routes,
        user: state.user
    };
}

const mapDispatchToProps = {
    setupNavigation,
    loadGroup,
    loadGroupByFriendlyUrl,
    addUserToGroup,
    requestGroupMembership,
    removeUserFromGroup,
    editGroup,
    uploadAvatar,
    uploadBanner,
    archiveGroup,
    reactivateGroup,
    getRecentGroups
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupPage);


var resizeImage = function (settings) {
    var file = settings.file;
    var maxSize = settings.maxSize;
    var reader = new FileReader();
    var image = new Image();
    var canvas = document.createElement('canvas');
    var dataURItoBlob = function (dataURI) {
        var bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
            atob(dataURI.split(',')[1]) :
            unescape(dataURI.split(',')[1]);
        var mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
        var max = bytes.length;
        var ia = new Uint8Array(max);
        for (var i = 0; i < max; i++)
            ia[i] = bytes.charCodeAt(i);
        return new Blob([ia], { type: mime });
    };
    var resize = function () {
        var width = image.width;
        var height = image.height;
        if (width > height) {
            if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
            }
        } else {
            if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
            }
        }
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(image, 0, 0, width, height);
        var dataUrl = canvas.toDataURL('image/png');
        return { blob: dataURItoBlob(dataUrl), data: dataUrl };
    };
    return new Promise(function (ok, no) {
        if (!file.type.match(/image.*/)) {
            no(new Error("Not an image"));
            return;
        }
        reader.onload = function (readerEvent) {
            image.onload = function () { return ok(resize()); };
            image.src = readerEvent.target.result;
        };
        reader.readAsDataURL(file);
    });
};


// WEBPACK FOOTER //
// ./src/components/groups/GroupPage.js